export default __webpack_public_path__ + "static/media/blackboard.c9503a97.png";